import { COMMON_LAYOUT_TYPE } from "../../ListPresentation/components/Testimonials/Constants";
import { COLOR_DIFF_LAYOUT, FILTER_CUSTOM_CLASS_2, CUSTOM, FILTER_CUSTOM_CLASS } from "../constant";
import Layout1 from "./FilterLayouts/Layout1";
import Layout2 from "./FilterLayouts/Layout2";
import RenderViewMoreAndLess from "./RenderViewMoreAndLess";

function CustomFilter(props) {
  const { data, config, filterName, filterId } = props;
  const { sortAndFilter: { appearances = {} } = {}} = config;
  const layout_desktop = config?.sortAndFilter?.layout_desktop;
  const currentLayout = appearances?.[filterId] || COMMON_LAYOUT_TYPE.ONE;

  function renderCustomFilterAccToLayout(item) {
    switch (currentLayout) {
      case COMMON_LAYOUT_TYPE.ONE:
        return <Layout1 filterData={item} type={CUSTOM} isSelect={false} filterName={filterName} />
      case COMMON_LAYOUT_TYPE.TWO:
        return <Layout2 filterData={item} isSelect={false} filterName={filterName} isCustomType />
    }
  }
  return (
    <RenderViewMoreAndLess
      isLayout2 = {layout_desktop === COMMON_LAYOUT_TYPE.TWO}
      data={data}
      childComponent={renderCustomFilterAccToLayout}
      customClass={COLOR_DIFF_LAYOUT?.includes(currentLayout) ? FILTER_CUSTOM_CLASS_2 : FILTER_CUSTOM_CLASS}
    />
  )
}

export default CustomFilter